
///
/// EarthBrowser
///
/// Created by Matt Giger on 2/12/2025
/// Copyright (c) 2025 Geodata Labs
///

import { Database } from "@/earthbrowser/database/Database"
import type { CountryInfo } from "@shared-types/location-info"

export class CountriesTable {
	public static async exec(sql: string, params?: unknown[]): Promise<void> {
		await Database.db.exec(sql, params)
	}

	public static async select(name: string): Promise<CountryInfo[]> {
		const statement = 'select * from countries where name = ?'
		const result = await Database.db.exec(statement, [name])
		return result as CountryInfo[]
	}

	public static async insert(countries: CountryInfo[]): Promise<void> {
		const statement = `INSERT INTO countries (country_code, iso3_code, name, area, population, tld, currency_code, currency_name, phone_code, languages) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
			ON CONFLICT(country_code) DO UPDATE SET iso3_code = excluded.iso3_code, name = excluded.name, area = excluded.area, population = excluded.population, tld = excluded.tld, currency_code = excluded.currency_code, currency_name = excluded.currency_name, phone_code = excluded.phone_code, languages = excluded.languages`
		// Reference-data ingest: low priority so it yields to visible-layer reads (see LocationsTable.insert)
		await Database.db.bulkInsert(statement, countries.map(cnt => [cnt.country_code, cnt.iso3_code, cnt.name, cnt.area, cnt.population, cnt.tld, cnt.currency_code, cnt.currency_name, cnt.phone_code, cnt.languages]), "low")
	}

	public static async create(db: Database): Promise<void> {
		await db.execMany([
			{ sql: `create table if not exists countries (
						country_code text primary key,
						iso3_code text,
						name text,
						area integer,
						population integer,
						tld text,
						currency_code text,
						currency_name text,
						phone_code text,
						languages text
					)` },
			{ sql: 'create index if not exists countries_name on countries (name)' },
		])
	}

	public static async getCount(): Promise<number> {
		const rows = await Database.db.exec(
			`select count(*) as count from countries`,
			[],
			"low"
		) as Array<{ count: number }>
		return Number(rows[0]?.count ?? 0)
	}

	public static async drop(): Promise<void> {
		await Database.db.exec('drop table if exists countries')
	}
}
